// controllers/color_input_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "swatch"];

  connect() {
    this.updateSwatch();
  }

  updateSwatch() {
    const color = this.inputTarget.value.trim();

    if (!color) {
      this.swatchTarget.style.backgroundColor = "";
      return;
    }


    if (this.isValidColor(color)) {
      this.swatchTarget.style.backgroundColor = color;
      this.swatchTarget.hidden = false;
    } else {
      this.swatchTarget.style.backgroundColor = "";
    }
  }

  validate() {
    const color = this.inputTarget.value.trim();

    if (!color) return;


    this.errorTarget.hidden = this.isValidColor(color);
  }

  isValidColor(color) {
    const el = document.createElement("div");
    el.style.color = "";
    el.style.color = color;

    const isValid = el.style.color !== "";

    // Clean up the element to avoid memory leaks
    el.remove();

    return isValid;
  }
}

